import { render, staticRenderFns } from "./FactorModule.vue?vue&type=template&id=5a873cb4&scoped=true&"
import script from "./FactorModule.vue?vue&type=script&lang=js&"
export * from "./FactorModule.vue?vue&type=script&lang=js&"
import style0 from "./FactorModule.vue?vue&type=style&index=0&id=5a873cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a873cb4",
  null
  
)

export default component.exports